// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-tooltip {
  position: relative;
  display: inline-block;
  cursor: help;
}
.info-tooltip .info-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background-color: #564ffd;
  color: white;
  border-radius: 50%;
  font-size: 12px;
  font-weight: bold;
  transition: background-color 0.2s ease;
}
.info-tooltip .info-icon:hover {
  background-color: #4338ca;
}
.info-tooltip .tooltip-text {
  visibility: hidden;
  position: absolute;
  z-index: 1000;
  width: 250px;
  background-color: white;
  color: #2d3748;
  text-align: left;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  opacity: 0;
  transition: opacity 0.2s ease;
  font-size: 13px;
  line-height: 1.4;
}
.info-tooltip .tooltip-text.top-right {
  bottom: 100%;
  right: 0;
  margin-bottom: 8px;
  transform: translateX(0);
}
.info-tooltip .tooltip-text::after {
  content: "";
  position: absolute;
  border-width: 6px;
  border-style: solid;
}
.info-tooltip .tooltip-text.top-right::after {
  top: 100%;
  right: 12px;
  border-color: white transparent transparent transparent;
}
.info-tooltip:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
.info-tooltip .tooltip-content h4 {
  margin: 0 0 6px 0;
  color: #1a202c;
  font-size: 14px;
  font-weight: 600;
}
.info-tooltip .tooltip-content p {
  margin: 6px 0;
}
.info-tooltip .tooltip-content ul,
.info-tooltip .tooltip-content ol {
  margin: 6px 0;
  padding-left: 16px;
}
.info-tooltip .tooltip-content li {
  margin: 3px 0;
}
.info-tooltip .tooltip-content strong {
  color: #1a202c;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/pages/Student/Performance/Diagnostic/components/Tooltip/styles.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,qBAAA;EACA,YAAA;AACF;AACE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,sCAAA;AACJ;AACI;EACE,yBAAA;AACN;AAGE;EACE,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,iFAAA;EAEA,UAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;AAFJ;AAII;EACE,YAAA;EACA,QAAA;EACA,kBAAA;EACA,wBAAA;AAFN;AAKI;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AAHN;AAMI;EACE,SAAA;EACA,WAAA;EACA,uDAAA;AAJN;AAQE;EACE,mBAAA;EACA,UAAA;AANJ;AAUI;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AARN;AAWI;EACE,aAAA;AATN;AAYI;;EAEE,aAAA;EACA,kBAAA;AAVN;AAaI;EACE,aAAA;AAXN;AAcI;EACE,cAAA;EACA,gBAAA;AAZN","sourcesContent":[".info-tooltip {\n  position: relative;\n  display: inline-block;\n  cursor: help;\n\n  .info-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 18px;\n    height: 18px;\n    background-color: #564ffd;\n    color: white;\n    border-radius: 50%;\n    font-size: 12px;\n    font-weight: bold;\n    transition: background-color 0.2s ease;\n\n    &:hover {\n      background-color: #4338ca;\n    }\n  }\n\n  .tooltip-text {\n    visibility: hidden;\n    position: absolute;\n    z-index: 1000;\n    width: 250px;\n    background-color: white;\n    color: #2d3748;\n    text-align: left;\n    border-radius: 8px;\n    padding: 12px;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),\n      0 2px 4px -1px rgba(0, 0, 0, 0.06);\n    opacity: 0;\n    transition: opacity 0.2s ease;\n    font-size: 13px;\n    line-height: 1.4;\n\n    &.top-right {\n      bottom: 100%;\n      right: 0;\n      margin-bottom: 8px;\n      transform: translateX(0);\n    }\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      border-width: 6px;\n      border-style: solid;\n    }\n\n    &.top-right::after {\n      top: 100%;\n      right: 12px;\n      border-color: white transparent transparent transparent;\n    }\n  }\n\n  &:hover .tooltip-text {\n    visibility: visible;\n    opacity: 1;\n  }\n\n  .tooltip-content {\n    h4 {\n      margin: 0 0 6px 0;\n      color: #1a202c;\n      font-size: 14px;\n      font-weight: 600;\n    }\n\n    p {\n      margin: 6px 0;\n    }\n\n    ul,\n    ol {\n      margin: 6px 0;\n      padding-left: 16px;\n    }\n\n    li {\n      margin: 3px 0;\n    }\n\n    strong {\n      color: #1a202c;\n      font-weight: 600;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
